module.exports = __webpack_public_path__ + "static/media/LK_Records.526aecd8.svg";